import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import Validation from "../../../commonComponents/Validation";
import { saveReportPost } from "../../../services/apiPosts";
import report from "../../../assets/img/pop/share.svg";
import ResponsePopup from "../../../commonComponents/responseSucessPopup";
import { Link } from "react-router-dom";

const InviteOthers = ({ isInvite, handleClose }) => {
    const linkRef = useRef(null);
  const [copied, setCopied] = useState(false);

   const handleCopy = () => {
    const text = linkRef.current?.textContent;
    if (text) {
      navigator.clipboard.writeText(text).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); 
        handleClose()// Reset after 2s
      }).catch(err => {
        console.error("Failed to copy: ", err);
      });
    }
  };
    return (
        <div>
            <Modal show={isInvite} onHide={handleClose}
                dialogClassName="small-custom-modal modal-dialog-centered">
                <Modal.Header closeButton>
                    <div className="popupheader">
                        <div className="mod-bor-icon" >
                            <img src={report} className="mod-icon"></img>
                        </div>
                        <div className="header">
                            <div className="signuup">Share Community Link</div>
                            <p className="Stronger"></p>

                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body>
                    <div className="form-control community-sharelink">
                        <p className="fov-text" ref={linkRef}>https://dh.srishtiprojects.com/</p>

                    </div>


                </Modal.Body>

                <Modal.Footer className="full-w" >
                    <button type="button" className="cancel-btn" onClick={() => { handleClose(); }}>Cancel</button>
                    <button className="next-btn" onClick={() => handleCopy()}> {" "} Copy Link{" "}</button>
                </Modal.Footer>


            </Modal>

        </div>
    );


};
export default InviteOthers;